/* global axios */

import ApiClient from './ApiClient';

class ScheduledMessagesAPI extends ApiClient {
    constructor() {
        super('scheduled_messages', { accountScoped: true });
    }

    get(params = {}) {
        const queryParams = new URLSearchParams();
        if (params.status) queryParams.append('status', params.status);
        if (params.conversation_id)
            queryParams.append('conversation_id', params.conversation_id);
        if (params.search) queryParams.append('search', params.search);
        const query = queryParams.toString();
        return axios.get(`${this.url}${query ? `?${query}` : ''}`);
    }

    create(data) {
        return axios.post(this.url, data);
    }

    update(id, data) {
        return axios.patch(`${this.url}/${id}`, data);
    }

    delete(id) {
        return axios.delete(`${this.url}/${id}`);
    }
}

export default new ScheduledMessagesAPI();
